import { ApplicationRoute } from '../../../constants/routes';
import { applicationContext } from '@philips-internal/oswald-ui-foundation';
import {  ModalService, ToastService } from '@philips-internal/oswald-ui-components';
import { FragmentNames } from '../../../codegen';
import { Placement, ToastLevel, ToastType } from '@philips-internal/oswald-ui-constants';
import { HistoryService } from '@philips-internal/oswald-ui-core/lib/services';

function ShowToast(message: string, toastLevel: ToastLevel, type: ToastType, infoToastId: string): void {
  const toastId = infoToastId;
  ToastService.close(toastId);
  ToastService.open({
    dismissible: true,
    highlight: false,
    id: toastId,
    level: toastLevel,
    message,
    placement: Placement.BOTTOM,
    showIcon: true,
    timeout: 5000,
    type,
  });
}

function RedirectUserToTimeline(fragmentNames: FragmentNames[]): void {
  const { encounterId, patientId } = HistoryService.getCurrentRouteParams();
  const redirectRoute = ApplicationRoute.ADEP_ELETRONIC_SERVICE_PERSONAL_INFORMATION;
  applicationContext.redirect(redirectRoute, { encounterId, patientId });
  applicationContext.clearNavigationStack();
  fragmentNames.map(value => ModalService.close(value));
}

export {
  ShowToast,
  RedirectUserToTimeline
}